import { Autocomplete, InputAdornment, TextField } from "@mui/material"
import { useCallback, useEffect, useState } from "react"
import throttle from "lodash.throttle"
import { useDispatch, useSelector } from "react-redux"
import { acGetUniqueDocuments } from "../../store/actions/ActionCompanyUsageLog"
import SearchIcon from '@mui/icons-material/Search';
import { formatCNPJ } from "../../utils"


export default function CNPJAutocomplete(props) {

    const dispatch = useDispatch()

    const usageLogState = useSelector(state => state.usageLog) || {}
    const [ inputValue, setInputValue ] = useState("")

    const uniqueDocuments = {
        data: usageLogState.uniqueDocumentsData || [],
        loading: usageLogState.isLoadingUniqueDocuments,
        error: usageLogState.hasErrorUniqueDocuments,
    }

    useEffect(() => {
        dispatch(acGetUniqueDocuments())
    }, [])

    const loadingText = "...carregando"

    const handleInputSearch = useCallback(
        throttle(
            (document) => {
                dispatch(acGetUniqueDocuments(document))
            },
            1000,
            {
                leading: true,
                trailing: true
            }
        ),
        []
    )

    return (
        <Autocomplete
            options={uniqueDocuments.data}
            getOptionLabel={formatCNPJ}
            filterOptions={(options, state) => {
                const input = state.inputValue.replace(/\D/g, "")
                return options.filter((option) =>
                    option.includes(input)
                )
            }}
            loading={uniqueDocuments.loading}
            loadingText="...carregando"
            inputValue={inputValue}
            onInputChange={(_, document) => {
                if (document === loadingText) {
                    return
                }
                setInputValue(document)
                handleInputSearch(document)
            }}

            forcePopupIcon={false}

            value={props.value}
            name={props.name}
            onBlur={props.onBlur}
            onChange={props.onChange}
            fullWidth={props.fullWidth}

            renderInput={(params) => (
                <TextField

                    {...{
                        ...props,
                        value: undefined,
                        name: undefined,
                        onBlur: undefined,
                        onChange: undefined,
                    }}

                    id={params.id}
                    disabled={params.disabled}
                    inputProps={params.inputProps}
                    InputLabelProps={{
                        ...params.InputLabelProps,
                        ...props.InputLabelProps
                    }}

                    InputProps={{
                        ...params.InputProps,
                        ...props.InputProps,
                        endAdornment: <>
                            {props.InputProps?.endAdornment}
                            {params.InputProps?.endAdornment}
                            <InputAdornment position="end">
                                <SearchIcon />
                            </InputAdornment>
                        </>
                    }}

                />
            )}
        />
    )
}

